const urlPattern = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
const  urlRegex = new RegExp(urlPattern);

// Will match www.hello.com, http://www.hello.com, https://www.hello.com, mailto:hello@hello.com, hello@hello.com
export function isValidUrl(url: string) {
  const escapedURL = encodeURI(url);
  return urlRegex.test(escapedURL);
}